
export default {
  props: {
    post: {
      type: Object,
      required: true,
    },
  },
  data () {
    return {
      displayFixtures: [],
      calendarPeriod: {},
      loadMore: {
        startIndex: 0,
        endIndex: 10,
        numCardsToShow: 10,
      },
      isLoading: false,
    };
  },
  computed: {
    displayFixturesChunk () {
      return this.displayFixtures;
      /*
      return this.displayFixtures.slice(
        this.loadMore.startIndex,
        this.loadMore.endIndex,
      );
      */
    },
    nextMatchFixture () {
      return this.displayFixtures[0].fixture ?? null;
    },
    nextMatchBlocks () {
      return (
        this.post?.acf?.fixture_list_config?.match_components?.next_match ??
        null
      );
    },
  },
};
